import type {
  IUpdateSingleAccessUserBody,
  IUpdateSingleAccessUserParams,
} from '@/app-package';
import axios from 'axios';

const updateSingleAccessProfile = async (
  params: IUpdateSingleAccessUserParams,
  body: IUpdateSingleAccessUserBody,
) => {
  const url = `/onboarding/single_access/${params.hash}/update`;

  await axios.post(url, body);
};

export default updateSingleAccessProfile;
